import http from "./http-common";

const login = (data) => {
  return http
    .post("/User/Login", data)
    .then((response) => {
      if (response) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem("token", JSON.stringify(response.data.token));
      }
      return response;
    })
    .catch((e) => console.log(e));
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const getToken = () => {
  return JSON.parse(localStorage.getItem("token"));
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.clear();
};

const generateOTP = (data) => {
  return http.post("/User/GenerateOTP", data);
};

const changePassword = (data) => {
  return http.post("/User/ForgetPassword", data);
};

const AuthService = {
  login,
  getCurrentUser,
  getToken,
  logout,
  generateOTP,
  changePassword,
};

export default AuthService;
